"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));
var _ykbUtils = require("ykb-utils");
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledPopover = require("./StyledPopover");
var _ModalContext = require("../Modal/context/ModalContext");
var _excluded = ["prefixCls", "error", "title", "content", "options", "trigger", "disable"];
function Popover(props) {
  var prefixCls = props.prefixCls,
    error = props.error,
    title = props.title,
    content = props.content,
    options = props.options,
    trigger = props.trigger,
    disable = props.disable,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var getRenderPropValue = function getRenderPropValue(propValue) {
    if (!propValue) {
      return null;
    }
    var isRenderFunction = typeof propValue === 'function';
    if (isRenderFunction) {
      return propValue();
    }
    return propValue;
  };
  var getOverlay = function getOverlay(prefixCls) {
    var selections = null;
    if (options && options.length > 0) {
      selections = /*#__PURE__*/_react.default.createElement(_StyledPopover.PopoverList, null, options.map(function (item, i) {
        return /*#__PURE__*/_react.default.createElement(_StyledPopover.PopoverItem, {
          key: i,
          onClick: item.onSelect,
          "aria-disabled": item.disabled
        }, item.text);
      }));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(_StyledPopover.PopoverTitle, {
      className: "".concat(prefixCls, "-title")
    }, getRenderPropValue(title)), selections ? selections : /*#__PURE__*/_react.default.createElement(_StyledPopover.PopoverContent, {
      className: "".concat(prefixCls, "-inner-content")
    }, getRenderPropValue(content)));
  };
  var getTrigger = function getTrigger(disable) {
    return disable ? [] : trigger;
  };
  return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/_react.default.createElement(_StyledPopover.StyledTooltipContainer, {
      error: error,
      theme: theme,
      prefixCls: prefixCls
    }, function (styledPrefix) {
      return /*#__PURE__*/_react.default.createElement(_ModalContext.ModalContextConsumer, null, function (value) {
        return /*#__PURE__*/_react.default.createElement(_rcTooltip.default, (0, _extends2.default)({
          getTooltipContainer: value !== null && value !== void 0 && value.renderOnBody ? function () {
            return value.container;
          } : _ykbUtils.containerChecker,
          prefixCls: styledPrefix,
          overlay: getOverlay(styledPrefix),
          trigger: getTrigger(disable)
        }, rest));
      });
    });
  });
}
Popover.propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  overlayClassName: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  prefixCls: _propTypes.default.string,
  title: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  content: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  placement: _propTypes.default.oneOf(['left', 'right', 'top', 'bottom', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight']),
  overlay: _propTypes.default.node,
  trigger: _propTypes.default.oneOf(['hover', 'click', 'focus']),
  disable: _propTypes.default.bool
};
Popover.displayName = 'Popover';
Popover.defaultProps = {
  placement: 'top',
  trigger: 'hover',
  mouseEnterDelay: 0.1,
  mouseLeaveDelay: 0.1,
  overlayStyle: {},
  disable: false
};
var _default = exports.default = Popover;